const miniCart = {
    init() {

        const miniCartTrigger = '.dropdown-back';
        const miniCartMenu = $('.dropdown-menu-mini-cart');
        const bodyBind = $('body');

        bodyBind.on('click', miniCartTrigger, function(e){
            e.preventDefault();
            miniCartMenu.toggle();
            $('.has-mega-menu').removeClass('active');
            $('body').removeClass('menu-active');
            $('.has-mega-menu').removeClass('menu-active');
            $('.masthead__mega-menu').removeClass('active');
        })



    }

}

export {miniCart}